// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"67352bbe","839":"ea986e02","850":"2f2c03b2"}[chunkId] + ".chunk.js";
};